
// Central config — checkout destination for every purchase CTA.
export const CHECKOUT_URL = "https://nuevoeje.com/cart/55301241307427:1";
export const WHATSAPP_URL =
  "https://wa.me/5491135050043?text=Hola%2C%20quiero%20info%20sobre%20The%20Bilingual%20Sales%20Machine";

export const PRICE = "$6.39";
export const PRICE_ANCHOR = "$172";

export const IMAGES = {
  heroBg:
    "https://cdn.magicpatterns.com/patterns/generated-images/56aca4be-96c8-4148-994d-741e271fce46.jpg",
  ebook:
    "https://cdn.magicpatterns.com/patterns/generated-images/7b715957-f8ae-4354-8692-c8de8ec0dd7b.jpg",
  author:
    "https://cdn.magicpatterns.com/patterns/generated-images/25e9509f-ee99-493e-88fd-571fba350973.jpg",
  lifestyle:
    "https://cdn.magicpatterns.com/patterns/generated-images/319e0fa8-66f0-419d-ab47-caaae77da24f.jpg",
  bonuses:
    "https://cdn.magicpatterns.com/patterns/generated-images/346aaa9a-b9f8-44d0-b429-de10d7c79359.jpg",
  logo: "https://cdn.magicpatterns.com/uploads/1Sy4AuV1pZ4kkqSeAXH2uQ/heylloyd-image-1784349485572.png",
};

export function goToCheckout() {
  window.location.assign(CHECKOUT_URL);
}
